import { TIdentificationRequestPrefill } from '@/models/chat.model';
import { stripPhoneCountryCode, toRawPhoneDigits } from '@/utils';
import { TUserDataFormValues, UserDataFormFields } from './types';

export const getUserDataFormInitialValues = (prefill?: TIdentificationRequestPrefill | null): TUserDataFormValues => ({
  [UserDataFormFields.PHONE]: prefill?.phone ? stripPhoneCountryCode(toRawPhoneDigits(prefill.phone)) : undefined,
  [UserDataFormFields.BIRTHDATE]: prefill?.birthdate || undefined,
});
